import timesheetLayoutTemplate from './timesheet-layout.html';

class TimesheetLayoutController {
  static $inject = [
    '$scope',
    '$stateParams',
    'Member',
    'Activity',
    'ActivityModal',
  ];

  selectedUser: any;
  activities: any[] = [];

  constructor(
    private $scope,
    private $stateParams,
    private Member,
    private Activity,
    private ActivityModal,
  ) {}

  $onInit() {
    this.Member.get(this.$stateParams.userId).then((user) => {
      this.selectedUser = user;
      this.$scope.$broadcast('user:selected', user);

      //Retrieve all user activities
      this.Member.getActivities(user.id).then((activities) => {
        this.activities = activities;
      });
    });
  }

  addActivity() {
    this.ActivityModal.add(
      this.selectedUser.organizations,
      this.selectedUser,
    ).then(
      (activity) => {
        this.activities.push(activity);

        if (activity.id) {
          this.Activity.update(activity);
        } else {
          this.Activity.save(activity);
        }
      },
      () => {
        //Modal dismissed
      },
    );
  }
}

export const TimesheetLayoutComponent = {
  template: timesheetLayoutTemplate,
  controller: TimesheetLayoutController,
};
